<div class="scaffold-sidebar-overlay">
  <div style="display:flex;">
    <div style="flex:1;">
      <div class="scaffold-editor-panel-heading">{{'version_log'| translation}}</div>

    </div>
    <div><p-button severity="info" variant="text" size='large' (click)="close()" aria-label="Close comments panel"><i class="fas fa-times"></i></p-button></div>
  </div>
  <hr />
  <div class="sidebar-scroll-area">

      <app-version-control [id]="id" [type]="type"></app-version-control>
  </div>
</div>
